export enum CompanyType {
  MANAGER = 'MANAGER',
  CLIENT = 'CLIENT',
}
